import { createContext, useContext, useEffect, useState } from 'react';
import {
  getFingertipsLinks,
  getHealthSnapshot,
  getHealthSnapshotCoveredMembersHw,
  getSavingsSnapshot,
  getOtherCompanyBenefits,
} from '../services/dashboard';
import { getAllCompanies } from '../services/pensionIndex';
import { AuthStore } from './auth';

export type HwDcDashboardState = {
  healthSnapshot: Array<any>;
  fingertipLinks: Array<any>;
  companiesMessages: Array<any>;
  savingsSnapshot: Array<any>;
  coveredFamilyMembers: Array<any>;
  otherCompanyBenefits: Array<any>;
};

export const HwDcDashboardStore =
  createContext<HwDcDashboardState>({
    healthSnapshot: [],
    fingertipLinks: [],
    companiesMessages: [],
    savingsSnapshot: [],
    coveredFamilyMembers: [],
    otherCompanyBenefits: [],
  });

const { Provider } = HwDcDashboardStore;

export const HwDcDashboardProvider = ({ children }: any) => {
  const [, , , selectedPersona] = useContext(AuthStore) || [];
  const [HwDcDashboardState, setHwDcDashboardState] =
    useState<HwDcDashboardState>({
      healthSnapshot: [],
      fingertipLinks: [],
      companiesMessages: [],
      savingsSnapshot: [],
      coveredFamilyMembers: [],
      otherCompanyBenefits: [],
    });

  useEffect(() => {
    let healthSnapshot = getHealthSnapshot();
    let fingertipLinks = getFingertipsLinks(selectedPersona);
    let companiesMessages = getAllCompanies(selectedPersona);
    let savingsSnapshot = getSavingsSnapshot();
    let coveredFamilyMembers = getHealthSnapshotCoveredMembersHw();
    let otherCompanyBenefits = getOtherCompanyBenefits();

    setHwDcDashboardState({
      healthSnapshot,
      fingertipLinks,
      companiesMessages,
      savingsSnapshot,
      coveredFamilyMembers,
      otherCompanyBenefits,
    });
  }, [selectedPersona]);

  return <Provider value={HwDcDashboardState}>{children}</Provider>;
};